import PropTypes from 'prop-types';
import { Link } from 'dibs-elements/exports/Link';

const CheckoutEmailLink = ({ address, subject, body }) => (
    <Link
        href={`mailto:${address}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
            body
        )}`}
    >
        {address}
    </Link>
);

CheckoutEmailLink.propTypes = {
    address: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    body: PropTypes.string.isRequired,
};

export default CheckoutEmailLink;
